(function () {
  var A = window.HLC_HUB || [];
  var I = window.HLC_I18N || {};
  var t = function (k, fb) { return I[k] != null ? I[k] : fb; };
  var $ = function (id) { return document.getElementById(id); };
  var unit = 'cm';

  function nums(s) { return (String(s || '').match(/\d+(?:\.\d+)?/g) || []).map(Number).slice(0, 3); }
  // Stored limits are floored to 0.1 cm (the floor rule: never round a limit up).
  // On an inch-native carrier that means 22 in is stored as 55.8, not 55.88 — so a
  // strict comparison rejects a bag at exactly the airline's own published limit.
  // Compare at the same 0.1 cm granularity the limits are stored in. This absorbs
  // the flooring artefact only: a real 0.9 cm overage still fails.
  var EPS = 0.1;
  function fits(b, l) {
    if (b.length < 3 || l.length < 3) return false;
    b = b.slice().sort(function (a, c) { return a - c; });
    l = l.slice().sort(function (a, c) { return a - c; });
    return b[0] <= l[0] + EPS && b[1] <= l[1] + EPS && b[2] <= l[2] + EPS;
  }
  // Canonical bag dims in cm — the source of truth for verdicts. Toggling the
  // unit only reformats the inputs; it never re-rounds the canonical values
  // (a 55 cm bag must not flip verdicts after cm -> in -> cm round-tripping).
  var cmVals = null;
  var toCm = function (v) { return unit === 'cm' ? v : v * 2.54; };
  function syncFromInputs() {
    var h = +$('h').value, w = +$('w').value, d = +$('d').value;
    cmVals = (!h || !w || !d) ? null : [toCm(h), toCm(w), toCm(d)];
  }
  function readCm() { return cmVals; }

  // Limits are converted with FLOOR (never round-to-nearest): a rounded-up
  // inch figure invites packing over the cm limit the airline enforces.
  var floor1 = function (v) { return Math.floor(v * 10) / 10; };
  function showDims(s) {
    var n = nums(s); if (n.length < 3) return s;
    if (unit === 'cm') return n[0] + ' × ' + n[1] + ' × ' + n[2] + ' cm';
    return n.map(function (v) { return floor1(v / 2.54); }).join(' × ') + ' in';
  }
  function showWeight(s, native) {
    if (!s) return '';
    var m = String(s).match(/\d+(?:\.\d+)?/);
    if (!m) return s;
    if (unit === 'cm') return s;
    var _lb = native === 'in' ? Math.round(parseFloat(m[0]) * 2.20462) : Math.floor(parseFloat(m[0]) * 2.20462);
    return _lb + ' lb';
  }

  function verdict(dims, a) {
    var p = nums(a.personal), c = nums(a.cabin);
    if (!p.length && !c.length) return null;
    if (p.length && fits(dims, p)) return 'pass';
    if (c.length && fits(dims, c)) return 'paid';
    return 'fail';
  }

  // Each row speaks its own carrier's fare model: on the US majors both bags are
  // free, so the European "fits the paid bag" wording would be flatly wrong.
  function labelFor(cls, a) {
    if (cls === 'fail') return t('noFit', "Doesn't fit");
    var m = I.models && I.models[(a && a.model) || 'free_paid'];
    if (m) return cls === 'pass' ? m.pass : m.paid;
    return cls === 'pass' ? t('fitsFree', 'Fits free') : t('fitsPaid', 'Fits the paid bag');
  }

  function render() {
    var dims = readCm(); drawBag(dims);
    var counts = { pass: 0, paid: 0, fail: 0 };
    A.forEach(function (a) {
      var row = document.querySelector('[data-hlc-row="' + a.handle + '"]');
      if (!row) return;
      var pill = row.querySelector('[data-pill]');
      var pillT = row.querySelector('[data-pill-t]');
      if (!dims) {
        if (pill) pill.hidden = true;
        row.classList.remove('is-pass', 'is-paid', 'is-fail');
        return;
      }
      var cls = verdict(dims, a);
      if (!cls) { if (pill) pill.hidden = true; return; }
      counts[cls]++;
      if (pill) {
        pill.hidden = false;
        pill.className = 'hlc-pill ' + cls;
        pillT.textContent = labelFor(cls, a);
      }
      row.classList.remove('is-pass', 'is-paid', 'is-fail');
      row.classList.add('is-' + cls);
    });
    ['pass', 'paid', 'fail'].forEach(function (k) {
      var el = document.querySelector('[data-sum="' + k + '"]');
      if (!el) return;
      el.textContent = dims ? counts[k] : '–';
      // A zero chip is context, not news — let it recede.
      var chip = el.closest('.s');
      if (chip) chip.classList.toggle('is-zero', !!dims && counts[k] === 0);
    });
    // Echo the entered bag in the sticky band: once the reader is deep in the
    // list, the inputs are off-screen and the numbers should travel with them.
    var yb = document.querySelector('[data-yourbag]');
    if (yb) {
      yb.hidden = !dims;
      if (dims) {
        var ybv = yb.querySelector('[data-yourbag-v]');
        if (ybv) ybv.textContent = unit === 'cm'
          ? Math.round(dims[0]) + ' × ' + Math.round(dims[1]) + ' × ' + Math.round(dims[2]) + ' cm'
          : (dims[0] / 2.54).toFixed(1) + ' × ' + (dims[1] / 2.54).toFixed(1) + ' × ' + (dims[2] / 2.54).toFixed(1) + ' in';
      }
    }
    // Proportional verdict bar under the chips: the one-glance answer.
    var bar = document.querySelector('[data-sumbar]');
    if (bar) {
      var total = counts.pass + counts.paid + counts.fail;
      bar.hidden = !dims || !total;
      if (dims && total) {
        ['pass', 'paid', 'fail'].forEach(function (k) {
          var seg = bar.querySelector('[data-seg="' + k + '"]');
          if (seg) seg.style.width = (counts[k] / total * 100) + '%';
        });
      }
    }
  }

  function refreshLimits() {
    A.forEach(function (a) {
      var row = document.querySelector('[data-hlc-row="' + a.handle + '"]');
      if (!row) return;
      var f = row.querySelector('[data-free]'), c = row.querySelector('[data-cabin]'), w = row.querySelector('[data-wt]');
      if (f && a.personal) f.textContent = showDims(a.personal);
      if (c && a.cabin) c.textContent = showDims(a.cabin);
      if (w && a.weight) w.textContent = showWeight(a.weight, a.unit);
    });
  }

  function drawBag(dims) {
    var svg = $('bagsvg'); if (!svg) return;
    if (!dims) { svg.innerHTML = ''; $('vizcap').textContent = ''; return; }
    var H = dims[0], W = dims[1], D = dims[2], max = Math.max(H, W, D), s = 120 / max;
    var w = W * s, h = H * s, dp = D * s * 0.5;
    var ox = (200 - (w + dp)) / 2, oy = (200 - (h + dp)) / 2 + dp;
    var p = function (x, y) { return x.toFixed(1) + ',' + y.toFixed(1); };
    svg.innerHTML =
      '<polygon points="' + p(ox, oy) + ' ' + p(ox + dp, oy - dp) + ' ' + p(ox + w + dp, oy - dp) + ' ' + p(ox + w, oy) + '" fill="#f3f3f3" stroke="#1a1a1a" stroke-width="1"/>' +
      '<polygon points="' + p(ox + w, oy) + ' ' + p(ox + w + dp, oy - dp) + ' ' + p(ox + w + dp, oy - dp + h) + ' ' + p(ox + w, oy + h) + '" fill="#e5e3df" stroke="#1a1a1a" stroke-width="1"/>' +
      '<rect x="' + ox + '" y="' + oy + '" width="' + w + '" height="' + h + '" fill="#faf9f7" stroke="#1a1a1a" stroke-width="1.2"/>';
    $('vizcap').textContent = unit === 'cm'
      ? Math.round(H) + ' × ' + Math.round(W) + ' × ' + Math.round(D) + ' cm'
      : (H / 2.54).toFixed(1) + ' × ' + (W / 2.54).toFixed(1) + ' × ' + (D / 2.54).toFixed(1) + ' in';
  }

  function setUnit(u) {
    if (u === unit) return;
    unit = u;
    ['h', 'w', 'd'].forEach(function (id, i) {
      if (cmVals) $(id).value = u === 'in' ? +(cmVals[i] / 2.54).toFixed(1) : +cmVals[i].toFixed(1);
    });
    $('uCm').classList.toggle('on', u === 'cm'); $('uIn').classList.toggle('on', u === 'in');
    [].forEach.call(document.querySelectorAll('[data-u]'), function (e) { e.textContent = u; });
    refreshLimits();
    render();
  }

  function initFilter() {
    var inp = $('hlcFilter'); if (!inp) return;
    inp.addEventListener('input', function () {
      var q = inp.value.trim().toLowerCase();
      [].forEach.call(document.querySelectorAll('[data-hlc-row]'), function (row) {
        row.style.display = !q || (row.getAttribute('data-name') || '').indexOf(q) !== -1 ? '' : 'none';
      });
    });
  }

  function init() {
    if (!$('hubRows')) return;
    $('uCm').onclick = function () { setUnit('cm'); };
    $('uIn').onclick = function () { setUnit('in'); };
    ['h', 'w', 'd'].forEach(function (id) { $(id).addEventListener('input', function () { syncFromInputs(); render(); }); });
    initFilter();
    syncFromInputs();
    render();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
